export default __webpack_public_path__ + "static/media/001-Australian Shepherd.163f88a5.svg";